import { render, staticRenderFns } from "./PaymentFailurePopup.vue?vue&type=template&id=294faf1b&scoped=true&"
import script from "./PaymentFailurePopup.vue?vue&type=script&lang=js&"
export * from "./PaymentFailurePopup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFailurePopup.vue?vue&type=style&index=0&id=294faf1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294faf1b",
  null
  
)

/* custom blocks */
import block0 from "./PaymentFailurePopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports